// extracted by mini-css-extract-plugin
export var o_cards_conocer = "cardsConocer-module--o_cards_conocer--04194";
export var o_cards_conocer__actions = "cardsConocer-module--o_cards_conocer__actions--a4196";
export var o_cards_conocer__body = "cardsConocer-module--o_cards_conocer__body--5779f";
export var o_cards_conocer__card = "cardsConocer-module--o_cards_conocer__card--fc24b";
export var o_cards_conocer__container = "cardsConocer-module--o_cards_conocer__container--e2172";
export var o_cards_conocer__cta = "cardsConocer-module--o_cards_conocer__cta--06100";
export var o_cards_conocer__desc = "cardsConocer-module--o_cards_conocer__desc--9a202";
export var o_cards_conocer__h2 = "cardsConocer-module--o_cards_conocer__h2--ae8ed";
export var o_cards_conocer__img = "cardsConocer-module--o_cards_conocer__img--9554a";
export var o_cards_conocer__info = "cardsConocer-module--o_cards_conocer__info--1e48f";
export var o_cards_conocer__intro = "cardsConocer-module--o_cards_conocer__intro--841cc";
export var o_cards_conocer__title = "cardsConocer-module--o_cards_conocer__title--e0f3c";